module.exports = __webpack_public_path__ + "static/bar04_2-6085c50d3bcfc1db678415f2e7c83054.png";